import React from "react";
import BannerHuawei from "../../img/banner-huawei.jpg"
import ScrollAnimation from 'react-animate-on-scroll';

const EventPartnersBase = ({ partnersBaseData = [] }) => {
    if (!partnersBaseData.length) return null;

    return (
        <section className="mb-20">
            <div className="container mx-auto px-5 mb-20">
                <div className="mb-10">
                    <ScrollAnimation animateIn="animate__fadeInUp"><h2
                        className="sm:text-4xl text-2xl mb-4 uppercase text-center">ІНІЦІАТОРИ ПРОЄКТУ</h2>
                    </ScrollAnimation>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                    <div className="overflow-hidden lg:max-h-[560px]">
                        <img src={BannerHuawei}/>
                    </div>
                    <div className="lg:max-w-[400px]">
                        <p className="mb-6"><b>Huawei</b> — один із глобальних лідерів інформаційно-комунікаційних технологій, інфраструктури і
                            розумних пристроїв, присутній у понад 170 країнах і регіонах.</p>
                        <p className="mb-6"><b>Huawei</b> прагне принести цифровізацію до кожної людини, родини та організації, щоб створити
                            об’єднаний інформацією і технологіями цифровий світ.</p>
                        <p className="mb-6"><b>Huawei Ukraine</b> вже понад 25 років є надійним інноваційним партнером України. Компанія
                            інвестує в наукові дослідження, створює кращі технології та відкриває нові можливості для розвитку
                            суспільства. <b>Women in Tech 2026</b> — частина довгострокової стратегії соціальної відповідальності
                            компанії.</p>
                    </div>
                </div>
            </div>
            {partnersBaseData.map(({partners_group: {group_status, tpb_items}}, groupIndex) => (
                <div className="container mx-auto mb-8 px-5 lg:mb-14" key={groupIndex}>
                    {/* Название */}
                    <h3 className="sm:text-4xl text-2xl mb-4 uppercase text-center">{group_status}</h3>

                    {/* Лого */}
                    <div className="flex flex-col sm:flex-row justify-center items-center flex-wrap gap-6 ">
                        {tpb_items.map(({acf: {p_url, p_thumbnail, p_logo_width}}, partnerIndex) => (
                            <a
                                key={`${groupIndex}-${partnerIndex}`}
                                href={p_url}
                                className="text-center block p-2"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ ...(p_logo_width && { maxWidth: `${p_logo_width}px` }) }}
                            >
                                <img
                                    src={p_thumbnail}
                                    alt={group_status}
                                    className="inline-block object-contain"
                                />
                            </a>
                        ))}
                    </div>
                </div>
            ))}
        </section>
    );
};

export default EventPartnersBase;